var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_178_9614)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24H6C4.4087 24 2.88258 23.3679 1.75736 22.2426C0.632141 21.1174 0 19.5913 0 18V6C0 4.4087 0.632141 2.88258 1.75736 1.75736C2.88258 0.632141 4.4087 0 6 0L18 0C19.5913 0 21.1174 0.632141 22.2426 1.75736C23.3679 2.88258 24 4.4087 24 6V18C24 19.5913 23.3679 21.1174 22.2426 22.2426C21.1174 23.3679 19.5913 24 18 24H15.75C15.75 23.5027 15.5525 23.0258 15.2008 22.6742C14.8492 22.3225 14.3723 22.125 13.875 22.125C13.3777 22.125 12.9008 22.3225 12.5492 22.6742C12.1975 23.0258 12 23.5027 12 24Z",
    fill: "#3764B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 6.75H18C18.8659 6.75109 19.6992 6.41929 20.3273 5.82325C20.9555 5.2272 21.3305 4.41252 21.3748 3.54772C21.4191 2.68292 21.1293 1.83417 20.5654 1.17704C20.0015 0.519908 19.2065 0.104682 18.345 0.01725C18.2303 0.010875 18.1166 0 18 0H6C4.4087 0 2.88258 0.632141 1.75736 1.75736C0.632141 2.88258 0 4.4087 0 6L0 18C0 15.0163 1.18526 12.1548 3.29505 10.045C5.40483 7.93526 8.26632 6.75 11.25 6.75Z",
    fill: "#507DD2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 12C16.8133 12 15.6533 12.3519 14.6666 13.0112C13.6799 13.6705 12.9109 14.6075 12.4567 15.7039C12.0026 16.8003 11.8838 18.0067 12.1153 19.1705C12.3468 20.3344 12.9182 21.4035 13.7574 22.2426C14.5965 23.0818 15.6656 23.6532 16.8295 23.8847C17.9933 24.1162 19.1997 23.9974 20.2961 23.5433C21.3925 23.0892 22.3295 22.3201 22.9888 21.3334C23.6481 20.3467 24 19.1867 24 18V6C24 7.5913 23.3679 9.11742 22.2426 10.2426C21.1174 11.3679 19.5913 12 18 12Z",
    fill: "#1E4BA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 6.75C19.5 6.94891 19.421 7.13968 19.2803 7.28033C19.1397 7.42098 18.9489 7.5 18.75 7.5H16.5C16.3011 7.5 16.1103 7.57902 15.9697 7.71967C15.829 7.86032 15.75 8.05109 15.75 8.25V11.25H18.585C18.696 11.25 18.8055 11.2746 18.9058 11.3221C19.0061 11.3696 19.0946 11.4387 19.1649 11.5245C19.2353 11.6103 19.2857 11.7106 19.3126 11.8183C19.3395 11.9259 19.3421 12.0382 19.3204 12.147L18.8704 14.397C18.8364 14.567 18.7446 14.72 18.6105 14.83C18.4764 14.9399 18.3084 15 18.135 15H15.75V24H12V15H9.75C9.55109 15 9.36032 14.921 9.21967 14.7803C9.07902 14.6397 9 14.4489 9 14.25V12C9 11.8011 9.07902 11.6103 9.21967 11.4697C9.36032 11.329 9.55109 11.25 9.75 11.25H12V8.25C12 7.05653 12.4741 5.91193 13.318 5.06802C14.1619 4.22411 15.3065 3.75 16.5 3.75H18.75C18.9489 3.75 19.1397 3.82902 19.2803 3.96967C19.421 4.11032 19.5 4.30109 19.5 4.5V6.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_178_9614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/FB.1d0b9d52c315aa194b17f0f2f8969ad0.svg";
export { ForwardRef as ReactComponent };